import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { images } from "assets/AssetHelper";
import { Stack, Box, Typography, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AppleIcon from "@mui/icons-material/Apple";
import AndroidIcon from "@mui/icons-material/Android";

export default function AuthLayout() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isShowBackToLoginBtn = [
    "/forget-password",
    "/verify-otp",
    "/reset-password",
    "/reset-password-success",
  ].includes(pathname);

  return (
    <Stack
      sx={{ height: "100vh" }}
      direction="row"
      justifyContent="space-between"
    >
      {/* ------------ SIDE IMAGE ------------ */}
      <Box
        sx={{
          width: { xs: "0%", md: "50%" },
          display: { xs: "none", md: "flex" },
          height: "100%",
          position: "relative",
          backgroundColor: "#6C4192",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            backgroundImage: `url(${images.loginLogoCover})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: { xs: "120%", md: "85%" },
            backgroundPosition: "center",
            opacity: 0.15,
          }}
        />

        <Box sx={{ position: "absolute", top: 24, left: 24 }}>
          <Box
            component={"img"}
            src={images.Logo}
            sx={{ width: 140, filter: "brightness(0) invert(1)" }}
          />
        </Box>

        <Stack
          spacing={3}
          // alignItems="center"
          sx={{
            color: "#fff",
            // textAlign: "center",
            px: 3,
            maxWidth: 760,
          }}
        >
          <Typography
            sx={{
              fontWeight: 800,
              fontSize: { xs: "36px", md: "56px" },
              lineHeight: 1.15,
            }}
          >
            {t("auth.layout.welcome_title")}
          </Typography>
          <Typography
            sx={{
              maxWidth: 620,
              opacity: 0.9,
              fontSize: { xs: "16px", md: "18px" },
            }}
          >
            {t("auth.layout.welcome_desc")}
          </Typography>
          <Stack direction="row" spacing={2}>
            <Button
              variant="contained"
              startIcon={<AppleIcon />}
              sx={{
                textTransform: "none",
                fontSize: 16,
                px: 2.5,
                py: 1.2,
                borderRadius: 2,
                backgroundColor: "rgba(255,255,255,0.18)",
                color: "#fff",
                backdropFilter: "blur(2px)",
                "&:hover": { backgroundColor: "rgba(255,255,255,0.24)" },
              }}
              onClick={() =>
                window.open(
                  "https://apps.apple.com/eg/app/cadeau/id6752618099",
                  "_blank",
                )
              }
            >
              {t("auth.layout.get_app")}
            </Button>
            <Button
              variant="contained"
              startIcon={<AndroidIcon />}
              sx={{
                textTransform: "none",
                fontSize: 16,
                px: 2.5,
                py: 1.2,
                borderRadius: 2,
                backgroundColor: "rgba(255,255,255,0.18)",
                color: "#fff",
                backdropFilter: "blur(2px)",
                "&:hover": { backgroundColor: "rgba(255,255,255,0.24)" },
              }}
              onClick={() =>
                window.open(
                  "https://play.google.com/store/apps/details?id=com.inzox.cadeau",
                  "_blank",
                )
              }
            >
              {t("auth.layout.get_app")}
            </Button>
          </Stack>
          <Typography
            sx={{
              position: "absolute",
              bottom: 20,
              color: "rgba(255,255,255,0.85)",
              fontSize: 12,
            }}
          >
            {t("auth.layout.copy_right", { year: new Date().getFullYear() })}
          </Typography>
        </Stack>
      </Box>

      <Stack
        sx={{
          width: { xs: "100%", md: "50%" },
          py: 5,
          justifyContent: "center",
          overflow: "auto",
        }}
      >
        {/* LOGO */}
        {/* <Box component={"img"} src={images.Logo} sx={{ width: "168px" }} /> */}
        {/* LOGIN / FORGET PASSWORD FORMS */}
        <Box sx={{ mx: "auto", maxWidth: "550px", gap: 5 }}>
          <Outlet />
          {/* ------------ BACK TO LOGIN ------------ */}
          {isShowBackToLoginBtn && (
            <Stack
              sx={{
                display: "flex",
                width: "fit-content",
                cursor: "pointer",
                mx: "auto",
                gap: 1,
                mt: 3,
              }}
              direction="row"
              alignItems="center"
              onClick={(_) => navigate("/")}
            >
              <ArrowBackIcon />
              <Typography
                sx={{
                  fontWeight: "500",
                  fontSize: "18px",
                  fontFamily: "Cairo",
                }}
              >
                {t("auth.layout.back_to_login")}
              </Typography>
            </Stack>
          )}
        </Box>
      </Stack>
    </Stack>
  );
}
